import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/product_insights", { replace: true });
  }, [navigate]);
  return (
    <div className="flex items-center justify-center h-full text-3xl font-bold text-gray-300">
      Nothing to see here
    </div>
  );
}
